import { useParams } from 'react-router'
import { Heading } from '@/components/base/heading'
// @ts-expect-error fragment is used in the query by fragment name
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Item, ItemFragment } from '@/components/items/item'
import { graphql } from '@/gql'
import { useQuery } from '@apollo/client/react'
import { Slimline as Error } from '@/components/error'
import { LoadingSkeleton } from '@/components/base/loading-skeleton'
import { Delete } from '@/components/items/delete'
import { useState } from 'react'
import { Button } from '@/components/base/button'

const ItemQuery = graphql(`
  query Item($id: ID!) {
    items(filters: { idEq: $id }) {
      nodes {
        id
        name
        ...ItemDetail
      }
    }
  }
`)

export const Show = () => {
  const { id } = useParams() as { id: string }

  const { data, loading, error } = useQuery(ItemQuery, { variables: { id } })

  const [showDelete, setShowDelete] = useState(false)

  if (loading) return <LoadingSkeleton table title />

  return (<div className="flex flex-col gap-3 grow">
    { error && <Error error={ error } /> }
    { data && <>
      <div className="flex flex-row justify-between items-center">
        <Heading level={ 1 } size="3xl">{ data.items.nodes[0].name }</Heading>
        <Button color="red" onClick={ () => setShowDelete(true) }>Delete</Button>
      </div>
      <Item id={ id } />
      <Delete id={ id } open={ showDelete } setOpen={ setShowDelete } />
    </> }
  </div>)
}
